export default {
  // The channels rail groups channels under labels; smart labels group by rule.
  newChannel: 'New channel',
  newLabel: 'New label',
  newLabelEllipsis: 'New label…',
  newSmartLabel: 'New smart label',
  editSmartLabel: 'Edit smart label',
  deleteLabel: 'Delete label',
  deleteSmartLabel: 'Delete smart label',
  markAllAsRead: 'Mark all as read',
  addToLabel: 'Add to label',
  moveToLabel: 'Move to label',
  ungroupFrom: 'Ungroup from “{{label}}”',
  nameContains: 'Name contains “{{text}}”',
};
